<template>
<div>
    <div v-if="loading" class="columns">
        <div class="column is-full has-text-centered">
            <img src="/loader-dark.svg">
        </div>
    </div>

    <div v-if="!loading" class="default-settings-title">
        <span class="account-name">Step 2: SSH key</span>
        <span class="default-settings-subtitle">Add the given SSH key in order to allow our bot to take backups.</span>
    </div>

    <div v-if="!loading" class="columns is-multiline">
        <div v-if="error" class="column is-full">
            <div class="notification is-danger" style="font-size: 13px; margin-top: 20px;">{{ error }}</div>
        </div>

        <div class="column is-full">
            <div style="color: #353b48; margin-bottom: 8px; margin-top: 10px;">Connect to the server via SSH</div>
            
            <div class="columns is-multiline">
                <div class="column is-12">
                    <div class="notification" style="font-size: 12px;">
                        {{ server.command_for_ssh_connection }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div v-if="!loading" class="columns is-multiline">
        <div class="column is-full">
            <div style="color: #353b48; margin-top: 10px;">Add the following entry to the authorized file</div>
            <div style="color: #868e96; margin-bottom: 8px; font-size: 13px;">{{ server.authorized_keys_file_absolute_path }}</div>
            
            <div class="columns is-multiline">
                <div class="column is-12">
                    <div class="notification" style="font-size: 12px; overflow-wrap: break-word;">
                        {{ server.ssh_key.public_key }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="!loading" class="columns is-multiline">
        <div class="column is-3">
            <div @click="checkSshConnection" :disabled="checkingSshConnection" :class="{ 'is-loading': checkingSshConnection }" class="button custom-button-size is-fullwidth is-info">Check SSH connection</div>
        </div>
        <div class="column is-3">
            <div @click="close" class="close-add-monitor-modal button custom-button-size is-fullwidth is-danger" :disabled="checkingSshConnection">Cancel</div>
        </div>
    </div>
</div>
</template>

<script>
import Api from '@/api';

export default {
    props: ['server'],

    data() {
        return {
            loading: true,
            checkingSshConnection: false,
            error: '',
        }
    },

    mounted() {
        this.initialSshConnectionCheck();
    },

    methods: {
        initialSshConnectionCheck() {
            this.loading = true;
            let endpoint = 'servers/' + this.server.id + '/ssh-connection';

            Api().get(endpoint)
                .then((success) => {
                    if (success.data.has_working_ssh_connection) {
                        this.moveToNextStep();
                    }
                })
                .catch((error) => {
                    this.error = 'Something went wrong. Our team was informed about the error and will have a look as soon as possible. In the meantime, you can reach us out at hi@weap.io';
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        checkSshConnection() {
            if (this.checkingSshConnection) {
                return;
            }

            this.checkingSshConnection = true;
            let endpoint = 'servers/' + this.server.id + '/ssh-connection';

            Api().get(endpoint)
                .then((success) => {
                    if (success.data.has_working_ssh_connection) {
                        this.moveToNextStep();
                    } else {
                        this.error = 'The weap.io Bot is not able to connect to the server. Please make sure the given public SSH key was added to the authorized_keys file.';
                    }
                })
                .catch((error) => {
                    this.error = 'Something went wrong. Our team was informed about the error and will have a look as soon as possible. In the meantime, you can reach us out at hi@weap.io';
                })
                .finally(() => {
                    this.checkingSshConnection = false;
                });
        },

        moveToNextStep() {
            Event.$emit('moveToDatabaseDetailsStep', this.server);
        },

        close() {
            if (this.checkingSshConnection) {
                return;
            }

            Event.$emit('closeAddDatabase');
        },
    },
}
</script>